import template from './main-table-body-row.html';

export default angular.module('gm.wealth.common')
  .directive('gmwMainTableBodyRow', gmwMainTableBodyRow)
  .name;

function gmwMainTableBodyRow() {
  'ngInject';

  const directive = {
    replace: true,
    restrict: 'E',
    template,
    transclude: true,
  };
  return directive;
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/common/directives/main-table-body-row/main-table-body-row.js